import { SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '50px',
        height: '20px',
        borderRadius: '8px',
      },
    },
  ],
})`
  width: auto;
`;

export const SecondRowWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const HorizonTitle = styled.span`
  ${typographyV2.uiXs};
  color: var(--text-default);
`;

export const HorizonPrefix = styled.span`
  ${typographyV2.titleSm};
  color: var(--text-soft);
`;

export const HorizonValue = styled.span<{ $isNegative: boolean }>`
  ${typographyV2.uiSm};
  font-family: var(--font-roboto-mono);
  color: ${props =>
    props.$isNegative ? 'var(--viz-bearish)' : 'var(--viz-bullish)'};
`;

export const HorizonWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  flex-direction: column;
  width: 20%;
  text-align: center;
  padding: 4px 0;
  border-radius: 4px;

  &:hover {
    background-color: ${props =>
      props.$isSelected ? 'var(--surface-default)' : 'var(--surface-hover)'};
    cursor: ${props => (props.$isSelected ? 'default' : 'pointer')};
  }

  ${props =>
    props.$isSelected &&
    `
        background-color: var(--surface-default);
    `}
`;
